import { Link, Navigate, useParams } from "react-router-dom";

import { useVariants } from "../lib/api";


// URL: /code/:code — resolves a ship code (e.g. "5801") to its owning
// variant, then redirects to /fleet/<variantId>?code=<code>. The code stays
// in the URL; TopBar/SiteStrip resolve it to the tail internally.
export default function CodePage() {
  const { code } = useParams();
  const { data, isLoading, isError, error } = useVariants();

  if (!code) return <Navigate to="/" replace />;

  if (isLoading) {
    return <p className="p-6 text-slate-500">Looking up code {code}…</p>;
  }
  if (isError) {
    return (
      <div className="m-6 rounded border border-red-200 bg-red-50 p-4 text-sm text-red-900">
        Fleet lookup failed: {(error as Error).message}
      </div>
    );
  }

  const variants = data?.variants ?? [];
  const owner = variants.find((v) =>
    (v.tails ?? []).some((t) => t.code === code),
  );

  if (!owner) {
    return (
      <div className="m-6 rounded border border-amber-200 bg-amber-50 p-4 text-sm text-amber-900">
        <p className="mb-2">
          Code <span className="font-mono font-semibold">{code}</span> isn't in
          any known fleet.
        </p>
        <Link to="/" className="text-sky-700 underline">Back to fleets</Link>
      </div>
    );
  }

  return (
    <Navigate
      to={`/fleet/${owner.variant_id}?code=${encodeURIComponent(code)}`}
      replace
    />
  );
}
